import { render, staticRenderFns } from "./lowerLevel.vue?vue&type=template&id=5fcc84a9&scoped=true"
import script from "./lowerLevel.vue?vue&type=script&lang=js"
export * from "./lowerLevel.vue?vue&type=script&lang=js"
import style0 from "./lowerLevel.vue?vue&type=style&index=0&id=5fcc84a9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc84a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fcc84a9')) {
      api.createRecord('5fcc84a9', component.options)
    } else {
      api.reload('5fcc84a9', component.options)
    }
    module.hot.accept("./lowerLevel.vue?vue&type=template&id=5fcc84a9&scoped=true", function () {
      api.rerender('5fcc84a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/lowerLevel.vue"
export default component.exports